import { create } from 'zustand';
import type { WidgetSpec } from '../types/analytics';

interface PendingWidget { title: string; spec: WidgetSpec; }

interface DashboardBuilderState {
  pending: PendingWidget | null;
  requestBuilder: (w: PendingWidget) => void;
  clear: () => void;

  // chat → CustomDashboards: select a dashboard (e.g. after create).
  pendingDashboardId: string | null;
  selectDashboard: (id: string) => void;
  clearDashboard: () => void;

  // CustomDashboards → chat: send a starter prompt (drained by CommandFooter).
  pendingPrompt: string | null;
  sendPrompt: (text: string) => void;
  clearPrompt: () => void;
}

export const useDashboardBuilderStore = create<DashboardBuilderState>((set) => ({
  pending: null,
  requestBuilder: (w) => set({ pending: w }),
  clear: () => set({ pending: null }),

  pendingDashboardId: null,
  selectDashboard: (id) => set({ pendingDashboardId: id }),
  clearDashboard: () => set({ pendingDashboardId: null }),

  pendingPrompt: null,
  sendPrompt: (text) => set({ pendingPrompt: text }),
  clearPrompt: () => set({ pendingPrompt: null }),
}));
